import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { ConnectionProvider } from './store/connection';
import { StoreProvider } from './store/store';
import { ConfirmProvider } from './ui/confirm';
import './styles.css';

// Registered only in production — in dev it would serve stale bundles and make
// every change look like it didn't apply.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Offline support is a nice-to-have; never let it break startup.
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StoreProvider>
      <ConnectionProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </ConnectionProvider>
    </StoreProvider>
  </StrictMode>,
);
